module.exports = __webpack_public_path__ + "img/microwaver-error.331519d.png";